<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="AddHistorique" :validation-schema="HistoriqueSchema">
        <div class="row">
         <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Numéro d'Ordre<span class="text-danger">*</span>
              </label>
              <Field name="numOrdre" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le numéro d'Ordre" />
              <ErrorMessage name="numOrdre" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Image <span class="text-danger">*</span>
              </label>
              <Field name="urlImage" type="file" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="urlImage" class="text-danger" />
            </div>
          </div>
          
           <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Desciption<span class="text-danger">*</span>
              </label>
              <Field name="description" as="textarea" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez la description" />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button class="default-btn me-20 transition border-0 fw-medium text-white pt-10 
                  pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Ajouter
              </button>
              <router-link to="/historique" class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                  class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { error, success } from "../../utils/utils";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
  name: "AddHistorique",
  components: {
    Form,
    Field,
    ErrorMessage,
  },

  setup: () => {
    const router = useRouter();

    const HistoriqueSchema = Yup.object().shape({
      description: Yup.string().required("La description est obligatoire"),
      numOrdre: Yup.string().required("Le numéro d'ordre est obligatoire"),
      urlImage: Yup.mixed().notRequired(),
    });

    const AddHistorique = async (values: any, { resetForm }: any) => {
      try {
        console.log("Données envoyées:", values);

        const response = await axios.post("/historique", values, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': '*/*'
          }
        });

        if (response.data.code === 201) {
          success(response.data.message || "Historique ajouté avec succès");
          resetForm();
          router.push({ name: "ListeHistoriquePage" });
        }
      } catch (err: any) {
        console.error("Erreur lors de l'ajout:", err);
        if (err.response?.data?.message) {
          error(err.response.data.message);
        } else {
          error("Une erreur est survenue lors de l'ajout de l'historique");
        }
      }
    };

    return {
      HistoriqueSchema,
      AddHistorique
    };
  },
});
</script>
